<template>
  <div>
    <Form :model="formData" :label-width="82"  :rules="formRules" ref="formData">
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="手机号" :class=" [{'ivu-form-item-error':phoneNumErr},'ivu-form-item-required']">
            <Input v-model="formData.phoneNum" @on-blur="validatePhone"></Input>
            <div v-show="phoneNumErr"  class="ivu-form-item-error-tip">输入正确的联系方式</div>
          </FormItem>
        </Col>
        <Col span="16" v-if="haSignUp===2">
          <img height="30" title="点击刷新" :src="`data:image/png;base64,${imgVerifycode}`" @click="getImgVerifycode" />
          <Input class="w-80" :class=" [{'ivu-form-item-error':imgCodeErr}]" v-model="imgCodeInput" placeholder="输入图形验证码" @on-blur="sendSmCode"></Input>
          <Input v-if="showSmInput" class="w-80" v-model="smCodeInput" placeholder="输入短信验证码" @on-blur="verifySmCcode"></Input>
          <span v-if ="validateSmCode===1"><Icon type="android-done" color="#85CC7A" class="icon"></Icon></span>
          <span v-if ="validateSmCode===2 && showSmInput" class="error-color">短信验证码错误</span>
        </Col>
        <Col span="16" v-if="haSignUp===1">
          <span style="line-height:32px">该手机号已注册</span>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="7" >
          <FormItem label="姓名" prop="name">
            <Input v-model="formData.name"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <div class="flex">
            <FormItem label="证件信息" prop="certType" class="certType">
              <Select v-model="formData.certType" style="width: 80px">
                <Option v-for="item in cardTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </FormItem>
            <FormItem label="" prop="certNum" class="certNum">
              <Input v-model="formData.certNum" style="width: 140px"></Input>
            </FormItem>
          </div>
        </Col>
        <Col span="7">
          <FormItem label="性别" prop="sex">
            <RadioGroup v-model="formData.sex">
              <Radio v-for=" (item) in genderTypeList" :key="`gender${item.value}`" :label="item.value">
                <span>{{item.text}}</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="出生年月" prop="birthday">
            <DatePicker placeholder="yyyy-mm-dd" v-model="formData.birthday" type="date" style="width: 100%"></DatePicker>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem label="工作类型" prop="jobCode">
            <Select v-model="formData.jobCode" style="width: 220px">
              <Option v-for="item in jobTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="国籍" prop="nationality">
            <Input v-model="formData.nationality"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="7">
          <FormItem label="婚姻状况" prop="marriage">
            <Select v-model="formData.marriage">
              <Option v-for="item in marryStatusList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="20">
          <FormItem label="客户通过哪些途径了解的该房源？(可多选)" prop="housePath">
            <Checkbox-group v-model="formData.housePath">
                <Checkbox v-for="(item,index) in housePaths" 
                :key="'floor'+index"
                :label="item.value+':'+item.text"
                >{{item.text}}</Checkbox>
              </Checkbox-group>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script type="text/ecmascript-6">

  //组件from  添加/修改 入住人


  import { formatDateTime } from "@/utils/format";
  import { addCondition, toAddCheckPhone, getImgVerifycode, sendSmsVerifycodeUrl, verifySmsVerifycode, addRenter, validIdCardNumber } from "api/occupancy";

  export default {
    created() {
      this.initData()
    },
    props: {
      projectFid: {
        type: String,
        default: ''
      }
    },
    watch: {

      phone(val){
        if(!val) return
        if(this.renterInfo.uid) {
          this.haSignUp = 1
          for (const key in this.renterInfo) {
            if( key === 'job'||key === 'relationship'|| key==='contractId') continue
            if(this.renterInfo[key]){
              this.formData[key] = this.renterInfo[key]
            }
          }
          this.formData.jobCode = this.renterInfo.job
          this.formData.relationshipCode = this.renterInfo.relationship
          if(this.formData.certType === 1 && this.formData.certNum) {
            validIdCardNumber(this.formData.certNum).then( res => {
              // 交验身份证信息，填充出生年月
              this.formData.birthday = formatDateTime(res.data.birthday,false)
            })
          }
        } else {
          this.haSignUp = 2
          this.imgCodeInput = ''
          this.validateSmCode = 0
          this.smCodeInput = ''
          this.showSmInput =false
          this.imgCodeErr = false
          this.getImgVerifycode()
        }

      },

    },
    data() {
      const validateDate = (rules,value,callback)=>{
        rules.type = typeof value === 'object' ? 'object':'string'
        if(!value){
          callback(new Error('请选择出生日期'));
        }
        callback();
      }
      const validatPhone = (rule, value, callback) => {
        const pattern = /^1\d{10}$/;
        if (!pattern.test(value)) {
          callback(new Error("输入正确的联系方式"));
        }
        callback();
      };

      const validatCertNum = (rule, value, callback)=>{
        if(this.formData.certType===1){
          validIdCardNumber(value).then( res => {
            // 交验身份证信息，填充出生年月
            this.formData.birthday = formatDateTime(res.data.birthday,false)
            callback()
          }).catch(() => {
            callback('输入正确的证件号');
          })
        }else {
          if(value){
            callback();
          }else{
            callback('输入正确的证件号');
          }
        }
      }
      // const validatCertNum1 = (rule, value, callback)=>{
      //   if(this.formData.certType===1){
      //     validIdCardNumber(value).then( () => {
      //       // 交验身份证信息，填充出生年月
      //       callback()
      //     }).catch(() => {
      //       callback('输入正确的证件号');
      //     })
      //   }else {
      //     if(value){
      //       callback();
      //     }else{
      //       callback('输入正确的证件号');
      //     }
      //   }
      // }
      const validatTujing = (rule, value, callback) => {
        if (value.length==0) {
          callback(new Error("请选择看房途径"));
        }
        callback();
      };
      return {
        prodTypeEnum:[
          {text:'APP',value:1},
          {text:'直播',value:2},
        ],
        phone:'',
        phoneNumErr:false,
        renterInfo:null,
        baseUrl: "",
        token: "",
        imgVerifycode:'',
        // imgCode:'',
        imgId:'',
        imgCodeInput:'',
        showSmInput:false,
        imgCodeErr:false,
        smCode:'',
        smCodeInput:'',
        validateSmCode:0,
        select1: "",
        cardTypeList: [],
        jobTypeList: [],
        genderTypeList:[],
        marryStatusList: [],
        // contractsRelList:[],
        haSignUp: 0, // 0 未验证， 1已注册，2未注册
        housePaths:[],

        formData: {
          uid:'',
          contractId:'',
          phoneNum:'',
          name: '',
          certType: '',
          certNum: '',
          sex: '',
          birthday: '',
          birthdayYear:'',
          birthdayMonday:'',
          //job:'',
          jobCode: '',
          nationality: '',
          certPic1: '',
          certPic2: '',
          marriage: '',
          housePath:[],
          emergencyContact: '',
          //relationship: '',
          relationshipCode:'',
          emcyCntPhone: '',
          // sharerEntities:[]

        },
        formRules: {
          //phoneNum: [{ required: true, validator: validateContactPhone, trigger: "blur" }],
          name: [{ required: true,message: " ",type: "string",trigger: "blur"}],
          certType:[{required: true,message: " ",type: "number",trigger: "change"}],
          certNum: [{required: true,validator:validatCertNum, message:' ',type: "string",trigger: "blur"}],
          sex: [{required: true,message: " ",type: "number",trigger: "change"}],
          birthday: [ { required:true,validator:validateDate, trigger:'change' }],
          jobCode: [{required: true,message: " ",type: "number", trigger: "change"}],
          nationality: [ {required: true,message: " ",type: "string",trigger: "blur"}],
          marriage: [{ required: true,message: " ",type: "number",trigger: "change"}],
          emergencyContact: [ {required: true,message: " ",type: "string", trigger: "blur" } ],
          relationshipCode: [ { required: true, message: " ", type: "number", trigger: "change"}],
          emcyCntPhone: [{ required: true, validator: validatPhone, trigger: "blur" }],
          housePath:[{required: true, message: "请选择了解途径", validator:validatTujing, trigger: "change"}]
        },

      };
    },
    computed: {},
    methods: {
      init(){
        this.clearForm()
        this.phone=''
        this.imgVerifycode = ''
        this.imgCodeInput  = ''
        this.showSmInput = false
        this.imgCodeErr = false

        this.validateSmCode = 0
        this.smCodeInput = ''
      },
      checkPhone(phoneNum){
        const params = {
          phoneNum:phoneNum,
          projectFid:this.projectFid
        }
        toAddCheckPhone(params).then( res => {
          this.renterInfo = res.data
          this.phone = phoneNum
          if(res.data.uid){
            this.formData.uid = res.data.uid
          }
        })
      },
      clearForm(){
        this.$refs["formData"].resetFields();
        for(const key in this.formData){
          this.formData[key] = ''
          this.formData.housePath = []
        }
        this.phoneNumErr = false

        this.haSignUp = 0
        this.validateSmCode = 0
      },
      initData() {
        addCondition().then(res => {
          this.cardTypeList = res.data.cardType
          this.jobTypeList = res.data.jobType
          this.genderTypeList = res.data.genderType
          this.marryStatusList = res.data.marryStatus
          this.housePaths = res.data.housePath;
          // this.contractsRelList = res.data.contractsRel
        });
      },
      getImgVerifycode(){
        this.imgCodeErr = false
        this.imgCodeInput = ''
        this.showSmInput = false
        this.validateSmCode = 0
        this.smCodeInput = ''
        getImgVerifycode().then( res => {
          this.imgVerifycode = res.data.imgData
          this.imgId = res.data.imgId
          // this.imgCode = res.data.imgCode
        })
      },
     async validate() {
        let re=null
        await  this.$refs['formData'].validate(bool => {
          const pattern = /^1\d{10}$/;
          this.phoneNumErr = pattern.test(this.formData.phoneNum) ? false : true
          re= bool&& !this.phoneNumErr
        })
        return re
      },
      formDataMonthDate(inputTime){
        const date = new Date(inputTime);
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return m+''+d
      },
      sendSmCode(){
        // if(this.imgCode.toLowerCase()===this.imgCodeInput.toLowerCase()){
        if(this.imgCodeInput) {
          // this.imgCodeErr = false
          // this.showSmInput = true
          const params = {
            phone:this.formData.phoneNum,
            type:1,
            imgId: this.imgId,
            imgVValue: this.imgCodeInput
          }
          sendSmsVerifycodeUrl(params).then( res => {
            // console.log(res)
            if(res.data.status === 'fail'){
              this.$Message.error(res.data.data)
              this.imgCodeErr = true
              this.showSmInput = false
            }else if(res.data.status === 'success'){
              this.showSmInput = true
              this.smCode = res.data.data
              this.imgCodeErr = false

            }
          })
        } else{
          this.showSmInput = false
        }

        // }else {
        //   this.imgCodeErr = true
        //   this.showSmInput = false
        // }
      },
      verifySmCcode(){
        this.validateSmCode= 0
        // if(this.smCodeInput !== this.smCode) {
        if(!this.smCodeInput){
          this.validateSmCode= 2
          return
        }
        const params = {
          type:1,
          phone:this.formData.phoneNum,
          vcode:this.smCodeInput
        }
        verifySmsVerifycode(params).then( res => {
          if(res.data.status === 'success') {
            this.checkPhone(this.phone)
            this.validateSmCode= 1 // 短信验证码成功
          }else {
            this.$Message.error(res.data.data)
            this.validateSmCode= 2 // 短信验证码失败
          }
        })
      },
      validatePhone(){
        const phoneNum = this.formData.phoneNum

        const pattern = /^1\d{10}$/;
        if (!pattern.test(phoneNum)) {
          this.phoneNumErr = true
        } else {
          if(phoneNum === this.phone) return
          this.checkPhone(phoneNum)
          this.phoneNumErr = false
          // 调接口查询手机号 是否注册  注册填充信息，未注册显示图片验证码和手机验证码
        }

      }
    }
  };
</script>
<style scoped>
  .imgwidth {
    width: 80px;
  }
  a {
    color: #cfa868;
  }

  img {
    vertical-align: middle;
  }
  .w-80 {
    width: 100px;
    margin-left: 8px;
    vertical-align: middle;
  }
  .icon{
    font-size: 18px;
    vertical-align:bottom;
    padding-left: 8px;
  }
  .delete-icon{
    padding-left: 0px;
  }
  .imgwidth {
    width: 167px;
    height: 118px;
  }
  a {
    color: #CFA868;
  }

  .upload-wrap {
    display: inline-block;
    line-height: 1;
    padding: 10px 4px;
  }
  .upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;

  }
  .ivu-upload {
    position: relative;

  }

  .ivu-upload  a {
    position :absolute;
    right: 0;
    bottom: -6px;
  }
  .upload.error {
    border-color:#F56356;
  }
  a.error-color {
    color:#F56356;
    bottom: -18px;

  }
  .title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 0px;
  }


</style>

